import { useEffect } from 'react'
import { useLocation, useNavigate } from 'react-router'
import { DEFAULT_LANGUAGE, languageService } from '#src/languageService.js'

/**
 * On a visitor's first ever visit to the English home page (`/`), detects the
 * browser's preferred language and, if it's a supported non-default language,
 * client-side redirects to that language's home (e.g. `/sv`).
 *
 * The detected language is persisted to localStorage so detection runs only once;
 * returning visitors (and anyone who has used the LanguageSwitcher) are left alone.
 * Renders nothing.
 */
export function HomeLanguageDetector(): null {
  const { pathname } = useLocation()
  const navigate = useNavigate()

  useEffect(() => {
    if (pathname !== '/') return // only the default-language home
    if (languageService.getStoredLanguage()) return // already seen this visitor

    const detected = languageService.detectBrowserLanguage()
    languageService.setStoredLanguage(detected) // remember, so detection never runs again
    if (detected !== DEFAULT_LANGUAGE) {
      void navigate(languageService.localizePath('/', detected), { replace: true })
    }
  }, [pathname, navigate])

  return null
}
